/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

Vue.directive('has-error', require('../admin/directives/has-error.vue').default);
Vue.component('slider', require('./slider.vue').default);
Vue.component('slider-base', require('./slider-base.vue').default);
Vue.component('gallery', require('./gallery.vue').default);
Vue.component('image-popup', require('./image-popup.vue').default);
Vue.component('spinner', require('./spinner.vue').default);
Vue.component('contact', require('./contact.vue').default);

const app = new Vue({
    data: {
        openMenu: false,
    },
    watch: {
        openMenu:  function (value) {
            if (value) {
                document.body.classList.add('no-scroll');
            } else {
                document.body.classList.remove('no-scroll');
            }
        }
    },
    el: '#app',
});
